import * as yup from 'yup';

// 🎯 Goal Schema
export const goalSchema = yup.object().shape({
  selectedGoal: yup.object().shape({ id: yup.string().required('mandatory') }),
  targetYear: yup.number().required('Target Year is required').positive('Must be a positive number'),
  currentCost: yup.number().required('current Liability is required').positive('Must be a positive number'),
  investmentAmount: yup.number().required('Amount is required').positive('Must be a positive number'),
  inflationRate: yup.number().required('Percentage is required').min(0, 'Percentage cannot be negative').max(100, 'Percentage cannot exceed 100'),
  // interestRate: yup.number().min(0, 'Percentage cannot be negative').max(100, 'Percentage cannot exceed 100'),
  //   goalAmount: yup.string().required('Goal Amount is required'),
});

// 🏦 Pot Schema
export const potSchema = yup.object().shape({
  potName: yup.string().required('Pot Name is required'),
  potType: yup.string().required('Pot Type is required'),
  potTypeRelatedTo: yup
    .object()
    .shape({ name: yup.string().required('Related to is required') })
    .required('Related to is Required'),
  growthRate: yup.number().required('Growth Rate is required').min(0, 'Growth Rate cannot be negative').max(100, 'Percentage cannot exceed 100'),
  potCategorisation: yup
    .object()
    .shape({ name: yup.string().required('Category Name is required'), value: yup.string().required('Category Value is required') }),
});

// Schema for each assetAllocation object
const assetAllocationSchema = yup.object().shape({
  allocationPercent: yup
    .number()
    .typeError('Percentage must be a number')
    .min(0, 'Percentage cannot be negative')
    .max(100, 'Percentage cannot exceed 100')
    .required('Percentage is required'),
  name: yup
    .object()
    .shape({ name: yup.string().required('Pot Name is required') })
    .required('Pot Name is Required'),
});

// Main schema with assetAllocations validation
export const assetAllocationFinalSchema = yup.object().shape({
  assetAllocations: yup.array().of(assetAllocationSchema).min(1, 'At least one pot allocation is required').required('Pot Allocations are required'),
});

// Schema for each transaction object
const transactionSchema = yup.object().shape({
  transactionType: yup
    .object()
    .shape({ name: yup.string().required('transactionType is required'), value: yup.string().required('transactionType is required') }),
  potName: yup.string().required('Pot Name is required'),
  totalValue: yup.string().required('Total Value is required'),
  transactionDate: yup.string().required('Date is required'),
});

// Main schema with transaction validation
export const transactionFinalSchema = yup
  .object()
  .shape({ simulatedTransactions: yup.array().of(transactionSchema).min(1, 'At least one is required').required('required') });
